import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import R, { contains, equals, propOr, path, merge, without, omit } from 'ramda';
import DragDropFiles from './drag-drop-files';

class DragDropContainer extends Component {
  render() {
    const {
      isEditable,
      updateMMProp,
      updateMM,
      MMReducer,
      downloadSingleFile,
      containerStateForViewers, // for viewing others
      updateStateForViewers, // for viewing others
      forLocationOrProductPages, // for supplier location and product pages
      findPhotosForTag, // for supplier location and product pages only
    } = this.props;

    const filesArray = (() => {
      if (isEditable) {
        if (path(['filteredMedia', 'length'], MMReducer)) return MMReducer.filteredMedia;
        else if (forLocationOrProductPages) return (findPhotosForTag || []);
        return (MMReducer.media || []);
      }
      if (!isEditable) {
        if (path(['filteredMedia', 'length'], containerStateForViewers)) return containerStateForViewers.filteredMedia;
        else if (forLocationOrProductPages) return (findPhotosForTag || []);
        return MMReducer.media;
      }
    })();

    const selectedFiles = () => {
      if (isEditable) return MMReducer.selectedFiles;
      return propOr([], 'selectedFiles', containerStateForViewers);
    };

    const addFileForIsEditable = (file) => {
      propOr([], 'selectedFiles', MMReducer).push(file);
      updateMMProp({ selectedFiles: MMReducer.selectedFiles });
    };

    const addFileForViewers = (file) => {
      const updatedSelectedList = propOr([], 'selectedFiles', containerStateForViewers);
      updatedSelectedList.push(file);
      updateStateForViewers('selectedFiles', updatedSelectedList);
    };

    return (
      <DragDropFiles
        isEditable={isEditable}
        forLocationOrProductPages={forLocationOrProductPages}
        deleteFileFunc={(removedFile, fileToRemove) => {
          const removedSelectedFile = forLocationOrProductPages ? MMReducer.media.filter(file => file.url !== fileToRemove.url) : removedFile || [];
          updateMMProp({
            savingMedia: true,
            media: removedSelectedFile || [],
            selectedFiles: without([fileToRemove], propOr([], 'selectedFiles', MMReducer).map(file => omit(['index'], file))),
          });
          updateMM({
            updateField: 'media',
            updateBody: removedSelectedFile || [],
          });
        }}
        downloadOneFile={(file) => downloadSingleFile([file])}
        filesArray={filesArray}
        dragEndsFunc={(updatedFileArrangement) => {
          updateMMProp({ savingMedia: true });
          updateMM({
            updateField: 'media',
            updateBody: updatedFileArrangement,
          });
        }}
        cardStyle={{ display: 'inline-block' }}
        isUpdating={MMReducer.savingMedia}
        selectedFiles={selectedFiles()}
        onThumbnailSelect={(file) => {
          if (isEditable) addFileForIsEditable(file);
          else addFileForViewers(file);
        }}
        onThumbnailUnselect={(updatedList) => {
          if (isEditable) updateMMProp({ selectedFiles: updatedList });
          else { updateStateForViewers('selectedFiles', updatedList); }
        }}
        onPreviewClick={(file, index) => {
          if (isEditable) {
            if (!contains(file.url, propOr([], 'selectedFiles', MMReducer).map(selectedFile => selectedFile.url))) addFileForIsEditable(file);
            updateMMProp({
              previewDialog: true,
              selectedFileIndex: index,
            });
          } else {
            if (!contains(file.url, propOr([], 'selectedFiles', containerStateForViewers).map(selectedFile => selectedFile.url))) addFileForViewers(file);
            updateStateForViewers('previewDialog', true);
            updateStateForViewers('selectedFileIndex', index);
          }
        }}
        openPreview={isEditable ? MMReducer.previewDialog : propOr(false, 'previewDialog', containerStateForViewers)}
        closePreview={() => {
          if (isEditable) updateMMProp({ previewDialog: false });
          else { updateStateForViewers('previewDialog', false); }
        }}
        updateUserHovering={(hovering) => {
          if (isEditable) updateMMProp({ hovering });
          else { updateStateForViewers('hovering', hovering); }
        }}
        isUserHovering={isEditable ? MMReducer.hovering : propOr(false, 'hovering', containerStateForViewers)}
        updateFileName={(updatedMediaList, updatedFile) => {
          const updateForLocOrProductPage = updatedMediaList ? updatedMediaList : MMReducer.media.map(obj => {
            if (equals(obj.url, updatedFile.url)) return merge(obj, { name: updatedFile.name });
            return obj;
          });
          const selectedFilesUpdate = MMReducer.selectedFiles.map(file => {
            if (updatedFile && equals(file.url, updatedFile.url)) return merge(file, { name: updatedFile.name });
            return file;
          });
          updateMMProp({
            savingMedia: true,
            media: updateForLocOrProductPage,
            selectedFiles: selectedFilesUpdate,
          });
          updateMM({
            updateField: 'media',
            updateBody: updateForLocOrProductPage,
          });
        }}
        uploadingFile={MMReducer.uploadingFile}
        indexToOpen={isEditable ? MMReducer.selectedFileIndex : containerStateForViewers.selectedFileIndex}
        changeFileIndex={isEditable ? (newIndex) => updateMMProp({ selectedFileIndex: newIndex }) : newIndex => updateStateForViewers('selectedFileIndex', newIndex)}
        removeIndividualTag={(tagIdToRemove) => {
          const fileIndexThatIsOpened = MMReducer.selectedFileIndex;
          const fileUrl = path([fileIndexThatIsOpened, 'url'], filesArray);
          const removedTag = without([tagIdToRemove], path([fileIndexThatIsOpened, 'tags'], filesArray));
          const mediaClone = MMReducer.media.map(file => {
            if (file.url === fileUrl) {
              return { ...file, tags: removedTag };
            }
            return file;
          });
          updateMM({
            updateField: 'media',
            updateBody: mediaClone,
          });
          updateMMProp({
            media: mediaClone,
          });
        }}
      />
    );
  }
}

DragDropContainer.propTypes = {
  isEditable: PropTypes.bool,
  updateMMProp: PropTypes.func,
  updateMM: PropTypes.func,
  MMReducer: PropTypes.object,
  downloadSingleFile: PropTypes.func,
  containerStateForViewers: PropTypes.object,
  updateStateForViewers: PropTypes.func,
  forLocationOrProductPages: PropTypes.bool,
  findPhotosForTag: PropTypes.array,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
});

export default connect(mapStateToProps)(DragDropContainer);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/drag-drop/drag-drop-container.jsx